import esLocale from '@fullcalendar/core/locales/es';
import frLocale from '@fullcalendar/core/locales/fr';

export function getSupportedLocales() {
    return [esLocale, frLocale]
}